"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _systemSetting = require("@/api/systemSetting");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'ImagePicker',
  props: {
    /**
     * v-model
     *
     * 最终返回：
     *
     * [
     *   'https://xxx.com/image/1.jpg',
     *   'https://xxx.com/image/2.jpg'
     * ]
     */
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    /**
     * 最大数量
     */
    maxCount: {
      type: Number,
      default: 5
    },
    /**
     * 最小数量
     */
    minCount: {
      type: Number,
      default: 1
    },
    /**
     * 最大宽度
     *
     * 超过则等比例缩放
     */
    maxWidth: {
      type: Number,
      default: 2000
    },
    /**
     * JPEG 压缩质量
     */
    quality: {
      type: Number,
      default: 0.8
    },
    /**
     * 最大文件大小
     *
     * 这里指压缩之前的原始图片
     *
     * 默认 15MB
     */
    maxFileSize: {
      type: Number,
      default: 15 * 1024 * 1024
    }
  },
  data: function data() {
    return {
      /**
       * 内部图片
       *
       * {
       *   id,
       *   url,
       *   name
       * }
       *
       * 注意：
       * 这里已经不再保存 Blob URL。
       *
       * url 永远是服务器返回的图片地址。
       */
      images: [],
      /**
       * 添加图片 Dialog
       */
      actionVisible: false,
      /**
       * 全屏预览
       */
      previewVisible: false,
      /**
       * 当前预览
       */
      previewIndex: 0,
      /**
       * touch 起始位置
       */
      touchStartX: 0,
      /**
       * 是否正在上传
       */
      uploading: false
    };
  },
  computed: {
    /**
     * 当前预览图片
     */
    currentPreview: function currentPreview() {
      return this.images[this.previewIndex] || null;
    },
    /**
     * 提示
     */
    tip: function tip() {
      return "\u81F3\u5C11 ".concat(this.minCount, " \u5F20\uFF0C\u6700\u591A ").concat(this.maxCount, " \u5F20");
    }
  },
  watch: {
    /**
     * 父组件 v-model 变化
     *
     * 主要用于：
     *
     * 1. 父组件初始化已有图片
     * 2. 父组件主动清空图片
     */
    value: {
      immediate: true,
      deep: true,
      handler: function handler(val) {
        var _this = this;
        if (!Array.isArray(val)) {
          return;
        }

        /**
         * 将父组件传入的 URL
         * 转换为内部 images 结构。
         *
         * 例如：
         *
         * value:
         * [
         *   'https://xxx.com/a.jpg',
         *   'https://xxx.com/b.jpg'
         * ]
         *
         * 转换成：
         *
         * images:
         * [
         *   {
         *     id: xxx,
         *     url: 'https://xxx.com/a.jpg',
         *     name: 'a.jpg'
         *   }
         * ]
         */
        this.images = val.filter(function (url) {
          return !!url;
        }).map(function (url, index) {
          return {
            id: "init_".concat(index, "_").concat(url),
            url: url,
            name: _this.getFileName(url)
          };
        });

        /**
         * 修正预览 index
         */
        if (this.previewIndex >= this.images.length) {
          this.previewIndex = Math.max(0, this.images.length - 1);
        }

        /**
         * 没有图片时关闭预览
         */
        if (this.images.length === 0) {
          this.previewVisible = false;
        }
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    /**
     * 防止组件销毁后 body 仍然不能滚动
     */
    document.body.style.overflow = '';
  },
  methods: {
    /**
     * =========================
     * 上传图片到服务器
     * =========================
     *
     * 如果你项目里已经有
     * uploadImageToServer(file)
     *
     * 可以直接把这里替换成你现有的实现。
     *
     * 这个方法必须最终返回：
     *
     * https://xxx.com/xxx.jpg
     *
     */
    uploadImageToServer: function () {
      var _uploadImageToServer = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(file) {
        var formData, response;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              formData = new FormData();
              formData.append('multipart', file);

              /**
               * 根据你的项目实际请求方式修改。
               *
               * 例如：
               *
               * const response =
               *   await this.$axios.post(
               *     '/api/upload/image',
               *     formData
               *   )
               */
              _context.n = 1;
              return (0, _systemSetting.commonMediaUpload)(formData);
            case 1:
              response = _context.v;
              /**
               * 假设后端：
               *
               * {
               *   code: 200,
               *   data: {
               *     url: 'https://xxx.com/a.jpg'
               *   }
               * }
               *
               * 如果你的实际返回结构不同，
               * 只需要修改这里。
               */
              console.log(2342424323, response);
              return _context.a(2, response);
          }
        }, _callee);
      }));
      function uploadImageToServer(_x) {
        return _uploadImageToServer.apply(this, arguments);
      }
      return uploadImageToServer;
    }(),
    /**
     * =========================
     * 打开添加
     * =========================
     */
    openImageAction: function openImageAction() {
      if (this.uploading) {
        return;
      }
      if (this.images.length >= this.maxCount) {
        this.$message.warning("\u6700\u591A\u53EA\u80FD\u4E0A\u4F20 ".concat(this.maxCount, " \u5F20\u56FE\u7247"));
        return;
      }
      this.actionVisible = true;
    },
    /**
     * =========================
     * 拍照
     * =========================
     */
    takePhoto: function takePhoto() {
      var _this2 = this;
      this.actionVisible = false;
      this.$nextTick(function () {
        if (!_this2.$refs.cameraInput) {
          return;
        }

        /**
         * 清空 value
         *
         * 允许用户连续拍摄/
         * 选择相同图片
         */
        _this2.$refs.cameraInput.value = '';
        _this2.$refs.cameraInput.click();
      });
    },
    /**
     * =========================
     * 相册
     * =========================
     */
    chooseAlbum: function chooseAlbum() {
      var _this3 = this;
      this.actionVisible = false;
      this.$nextTick(function () {
        if (!_this3.$refs.albumInput) {
          return;
        }

        /**
         * 清空 value
         */
        _this3.$refs.albumInput.value = '';
        _this3.$refs.albumInput.click();
      });
    },
    /**
     * =========================
     * 文件选择
     * =========================
     */
    handleFileChange: function () {
      var _handleFileChange = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(event) {
        var files, remain, selectedFiles, i, file, compressedFile, url, item, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              files = Array.from(event.target.files || []);
              /**
               * 清空 input
               *
               * 这样用户可以重复选择同一张图片
               */
              event.target.value = '';
              if (files.length) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              remain = this.maxCount - this.images.length;
              if (!(remain <= 0)) {
                _context2.n = 2;
                break;
              }
              this.$message.warning("\u6700\u591A\u53EA\u80FD\u4E0A\u4F20 ".concat(this.maxCount, " \u5F20\u56FE\u7247"));
              return _context2.a(2);
            case 2:
              /**
               * 截取允许的数量
               */
              selectedFiles = files.slice(0, remain);
              /**
               * 超过数量
               */
              if (files.length > remain) {
                this.$message.warning("\u6700\u591A\u4E0A\u4F20 ".concat(this.maxCount, " \u5F20\u56FE\u7247\uFF0C\u5DF2\u9009\u62E9 ").concat(remain, " \u5F20"));
              }
              this.uploading = true;
              _context2.p = 3;
              i = 0;
            case 4:
              if (!(i < selectedFiles.length)) {
                _context2.n = 13;
                break;
              }
              file = selectedFiles[i];
              _context2.p = 5;
              if (!(!file.type || file.type.indexOf('image/') !== 0)) {
                _context2.n = 6;
                break;
              }
              this.$message.warning("".concat(file.name, " \u4E0D\u662F\u56FE\u7247"));
              return _context2.a(3, 12);
            case 6:
              if (!(file.size > this.maxFileSize)) {
                _context2.n = 7;
                break;
              }
              this.$message.warning("".concat(file.name, " \u539F\u56FE\u8D85\u8FC7 15MB"));
              return _context2.a(3, 12);
            case 7:
              _context2.n = 8;
              return this.compressImage(file);
            case 8:
              compressedFile = _context2.v;
              /**
               * =========================
               * 4. 上传服务器
               * =========================
               */
              this.$message.info("\u6B63\u5728\u4E0A\u4F20 ".concat(file.name, "..."));
              _context2.n = 9;
              return this.uploadImageToServer(compressedFile);
            case 9:
              url = _context2.v;
              if (url) {
                _context2.n = 10;
                break;
              }
              throw new Error('服务器没有返回图片地址');
            case 10:
              /**
               * =========================
               * 6. 保存服务器图片地址
               * =========================
               *
               * 注意：
               *
               * 这里不再：
               *
               * URL.createObjectURL()
               *
               * 直接使用服务器 URL。
               */
              item = {
                id: Date.now() + '_' + Math.random().toString(36).substr(2, 9),
                url: url,
                name: compressedFile.name
              };
              /**
               * =========================
               * 7. 加入图片列表
               * =========================
               */
              this.images.push(item);
              _context2.n = 12;
              break;
            case 11:
              _context2.p = 11;
              _t = _context2.v;
              console.error('图片处理/上传失败:', _t);
              this.$message.error("".concat(file.name, " \u4E0A\u4F20\u5931\u8D25"));
            case 12:
              i++;
              _context2.n = 4;
              break;
            case 13:
              _context2.p = 13;
              this.uploading = false;
              return _context2.f(13);
            case 14:
              /**
               * =========================
               * 通知父组件
               * =========================
               */
              this.emitValue();
            case 15:
              return _context2.a(2);
          }
        }, _callee2, this, [[5, 11], [3,, 13, 14]]);
      }));
      function handleFileChange(_x2) {
        return _handleFileChange.apply(this, arguments);
      }
      return handleFileChange;
    }(),
    /**
     * =========================
     * 图片压缩
     * =========================
     */
    compressImage: function compressImage(file) {
      var _this4 = this;
      return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.onload = function (event) {
          var img = new Image();
          img.onload = function () {
            var width = img.naturalWidth;
            var height = img.naturalHeight;

            /**
             * =========================
             * 等比例缩放
             * =========================
             */
            if (width > _this4.maxWidth) {
              height = Math.round(height * _this4.maxWidth / width);
              width = _this4.maxWidth;
            }

            /**
             * =========================
             * Canvas
             * =========================
             */
            var canvas = document.createElement('canvas');
            canvas.width = width;
            canvas.height = height;
            var ctx = canvas.getContext('2d');
            if (!ctx) {
              reject(new Error('浏览器不支持 Canvas'));
              return;
            }

            /**
             * 图片质量
             */
            ctx.imageSmoothingEnabled = true;
            ctx.imageSmoothingQuality = 'high';

            /**
             * 绘制图片
             */
            ctx.drawImage(img, 0, 0, width, height);

            /**
             * =========================
             * 输出 JPEG
             * =========================
             */
            canvas.toBlob(function (blob) {
              if (!blob) {
                reject(new Error('图片压缩失败'));
                return;
              }

              /**
               * 保留原文件名
               */
              var fileName = _this4.changeExtension(file.name, 'jpg');
              var compressedFile = new File([blob], fileName, {
                type: 'image/jpeg',
                lastModified: Date.now()
              });
              resolve(compressedFile);
            }, 'image/jpeg', _this4.quality);
          };
          img.onerror = function () {
            reject(new Error('无法读取图片'));
          };
          img.src = event.target.result;
        };
        reader.onerror = function () {
          reject(new Error('读取文件失败'));
        };
        reader.readAsDataURL(file);
      });
    },
    /**
     * =========================
     * 修改扩展名
     * =========================
     */
    changeExtension: function changeExtension(fileName, extension) {
      var index = fileName.lastIndexOf('.');
      if (index === -1) {
        return fileName + '.' + extension;
      }
      return fileName.substring(0, index) + '.' + extension;
    },
    /**
     * =========================
     * 获取文件名
     * =========================
     */
    getFileName: function getFileName(url) {
      if (!url) {
        return '';
      }
      try {
        var pathname = new URL(url).pathname;
        var parts = pathname.split('/');
        return parts[parts.length - 1] || '';
      } catch (error) {
        /**
         * 如果不是完整 URL，
         * 例如：
         *
         * /upload/a.jpg
         */
        var _parts = url.split('/');
        return _parts[_parts.length - 1] || '';
      }
    },
    /**
     * =========================
     * 删除
     * =========================
     */
    removeImage: function removeImage(index) {
      var item = this.images[index];
      if (!item) {
        return;
      }

      /**
       * 注意：
       *
       * 这里不再：
       *
       * URL.revokeObjectURL()
       *
       * 因为 url 是服务器地址。
       */
      this.images.splice(index, 1);

      /**
       * 修正预览 index
       */
      if (this.previewIndex >= this.images.length) {
        this.previewIndex = Math.max(0, this.images.length - 1);
      }

      /**
       * 如果删除后没有图片
       */
      if (this.images.length === 0) {
        this.previewVisible = false;
      }

      /**
       * 通知父组件
       */
      this.emitValue();
    },
    /**
     * =========================
     * v-model
     * =========================
     *
     * 现在 v-model 返回：
     *
     * [
     *   'https://xxx.com/a.jpg',
     *   'https://xxx.com/b.jpg'
     * ]
     */
    emitValue: function emitValue() {
      var urls = this.images.map(function (item) {
        return item.url;
      });

      /**
       * Vue2 v-model
       */
      this.$emit('input', urls);

      /**
       * 如果父组件需要完整图片信息，
       * 可以监听：
       *
       * @images-change
       */
      this.$emit('images-change', this.images);
    },
    /**
     * =========================
     * 预览
     * =========================
     */
    previewImage: function previewImage(index) {
      if (!this.images[index]) {
        return;
      }
      this.previewIndex = index;
      this.previewVisible = true;

      /**
       * 禁止背景滚动
       */
      document.body.style.overflow = 'hidden';
    },
    /**
     * =========================
     * 关闭预览
     * =========================
     */
    closePreview: function closePreview() {
      this.previewVisible = false;
      document.body.style.overflow = '';
    },
    /**
     * =========================
     * 上一张
     * =========================
     */
    previewPrev: function previewPrev() {
      if (this.images.length <= 1) {
        return;
      }
      this.previewIndex = (this.previewIndex - 1 + this.images.length) % this.images.length;
    },
    /**
     * =========================
     * 下一张
     * =========================
     */
    previewNext: function previewNext() {
      if (this.images.length <= 1) {
        return;
      }
      this.previewIndex = (this.previewIndex + 1) % this.images.length;
    },
    /**
     * =========================
     * 手机左右滑动开始
     * =========================
     */
    handleTouchStart: function handleTouchStart(event) {
      if (!event.touches || !event.touches.length) {
        return;
      }
      this.touchStartX = event.touches[0].clientX;
    },
    /**
     * =========================
     * 手机左右滑动结束
     * =========================
     */
    handleTouchEnd: function handleTouchEnd(event) {
      if (!event.changedTouches || !event.changedTouches.length) {
        return;
      }
      var endX = event.changedTouches[0].clientX;
      var distance = endX - this.touchStartX;

      /**
       * 至少滑动 50px
       */
      if (Math.abs(distance) < 50) {
        return;
      }
      if (distance > 0) {
        this.previewPrev();
      } else {
        this.previewNext();
      }
    }
  }
};